<template>
    <div class="card-body py-1">
        <div class="d-flex justify-content-between">
            <div class="relative" :style="`width: 310px;height:${31 * (defaultRowsCount + 2)}px`">
                <div v-if="selectedColumns.length" class="column-square-dropdown" :style="getColSettingsLeft">
                    <RowColumnActions
                        @delete="handleDeleteColumn()"
                        @duplicate="duplicateColumn()"
                        @delete-text="clearColumns()"
                    />
                </div>
                <!-- BEGIN: Head Row -->
                <div class="table-cell-row d-flex align-items-center">
                    <button :class="{ active: allCellsSelected }" class="btn btn-sm drag-indicator" @click="toggleSelectAll">
                        <div class="drag-indicator-circle-row">
                            <div class="drag-indicator-circle"></div>
                            <div class="drag-indicator-circle"></div>
                        </div>
                        <div class="drag-indicator-circle-row">
                            <div class="drag-indicator-circle"></div>
                            <div class="drag-indicator-circle"></div>
                        </div>
                    </button>
                    <div
                        v-for="val in itemData.columns_count"
                        :key="val"
                        class="cell-square cursor-pointer"
                        :class="{ 'ml-2': val === 1 }"
                        style="width: 18px"
                    >
                        <div class="addNewColumnBetween">
                            <div
                                class="icon"
                                :style="{ width: `14px`, height: `14px`, borderRadius: `50%` }"
                                @click="addColumnBetween(val)"
                            >
                                <div class="d-flex justify-content-center align-items-center h-100 w-100">
                                    <IconPlus />
                                </div>
                            </div>
                            <div class="column-line"></div>
                        </div>
                        <div
                            :class="
                                selectedColumns.includes(val) || (allCellsSelected && val <= itemData.columns_count)
                                    ? 'cell-square-circle-selected'
                                    : 'cell-square-circle'
                            "
                            @click="selectColumn(val)"
                        ></div>
                    </div>
                </div>
                <!-- END: Head Row -->

                <!-- BEGIN: Table Rows -->
                <div v-for="row in defaultRowsCount" :key="row" class="table-cell-row" style="position: relative">
                    <div class="add-row-block" @click="addNewRow(row)">
                        <div class="add-row">
                            <div class="icon-block">
                                <div class="icon">+</div>
                            </div>
                            <div class="line"></div>
                        </div>
                    </div>
                    <div class="d-flex" :style="getRowPosition(row)">
                        <div :class="{ 'cursor-pointer': row <= itemData.rows_count }" class="cell-square">
                            <div v-if="activeCellRow === row" class="cell-square-dropdown">
                                <RowColumnActions
                                    @delete="handleDeleteRow(row)"
                                    @duplicate="duplicateRow(row)"
                                    @delete-text="clearRow(row)"
                                />
                            </div>
                            <div v-if="row <= itemData.rows_count" @click="setActiveRowCircle(row)">
                                <div
                                    :class="
                                        activeCellRow === row || (allCellsSelected && row <= itemData.rows_count)
                                            ? 'cell-square-circle-selected'
                                            : 'cell-square-circle'
                                    "
                                ></div>
                            </div>
                        </div>
                        <div v-for="col in defaultColumnsCount" :key="col" :style="getMarginStyle(row, col)">
                            <div
                                v-if="!itemData.table_data[row - 1]?.cells[col - 1]?.disabled"
                                class="table-cell-square cursor-pointer"
                                style="position: relative"
                                :class="{
                                    'ml-2': col === 0,
                                    'chosen-cell-border': col <= itemData.columns_count && row <= itemData.rows_count,
                                    'hovered-cell':
                                        hoverItems.col !== null &&
                                        ((hoverItems.col >= col && hoverItems.row >= row && col > itemData.columns_count) ||
                                            (row > itemData.rows_count && row <= hoverItems.row && col <= hoverItems.col)),
                                    'active-cell':
                                        (inputItem.col === col && inputItem.row === row) ||
                                        (allCellsSelected && col <= itemData.columns_count && row <= itemData.rows_count),
                                    'selected-columns':
                                        (selectedColumns.includes(col) && row <= itemData.rows_count) ||
                                        (activeCellRow === row && col <= itemData.columns_count) ||
                                        (selectedCells.length > 0 &&
                                            selectedCells.some((item) => item.row === row && item.columns.includes(col))),
                                    'hover-remove-cell':
                                        (hoverItems.col !== null &&
                                            col <= itemData.columns_count &&
                                            row <= itemData.rows_count &&
                                            row > hoverItems.row) ||
                                        (col > hoverItems.col &&
                                            row < hoverItems.row &&
                                            col <= itemData.columns_count &&
                                            row <= itemData.rows_count),
                                }"
                                :style="{
                                    width:
                                        (itemData.table_data[row - 1]?.cells[col - 1]?.style.col_span > 1
                                            ? getCellWidth(itemData.table_data[row - 1]?.cells[col - 1]?.style.col_span)
                                            : defaultCellLength.width) + 'px',
                                    height:
                                        (itemData.table_data[row - 1]?.cells[col - 1]?.style.row_span > 1
                                            ? getCellHeight(itemData.table_data[row - 1]?.cells[col - 1]?.style.row_span)
                                            : defaultCellLength.height) + 'px',
                                    zIndex:
                                        itemData.table_data[row - 1]?.cells[col - 1]?.style.col_span > 1 ||
                                        itemData.table_data[row - 1]?.cells[col - 1]?.style.row_span > 1
                                            ? 2
                                            : 1,
                                }"
                                @mouseenter="handleCellHover(row, col)"
                                @mouseleave="handleCellLeave"
                                @click="handleCellClick(row, col)"
                            >
                                <div
                                    v-if="hoverItems.row === row && hoverItems.col === col"
                                    class="w-100 h-100 d-flex justify-content-center align-items-center"
                                >
                                    <div class="bg-primary" :style="{ width: `14px`, height: `14px`, borderRadius: `50%` }">
                                        <div class="d-flex justify-content-center align-items-center h-100 w-100">
                                            <IconPlus />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="row === defaultRowsCount" class="d-flex" :style="getRowPosition(row + 1)">
                        <!-- new row -->
                        <div v-if="defaultRowsCount === itemData.rows_count" class="table-cell-row">
                            <div class="table-cell-square cursor-pointer" @click="addNewTableRow">
                                <div class="new-row-addition">
                                    <div
                                        class="bg-primary d-flex justify-content-center align-items-center"
                                        :style="{ width: `14px`, height: `14px`, borderRadius: `50%` }"
                                    >
                                        <IconPlus />
                                    </div>
                                </div>
                            </div>
                            <div
                                v-for="col in defaultColumnsCount"
                                :key="col"
                                class="table-cell-square"
                                style="position: relative; margin-left: 1px"
                                :class="{ 'ml-1': col === 0 }"
                            ></div>
                        </div>
                        <hr />
                    </div>
                </div>
                <!-- END: Table Rows -->
            </div>
            <div class="mt-2 d-flex flex-column table-settings">
                <IconButton
                    v-b-tooltip.hover
                    icon="ListNested"
                    title="Clear All"
                    variant="danger"
                    class="mb-1 btn-focus-none d-flex justify-content-center align-items-center"
                    @click="
                        clearCells.active = true
                        clearCells.isAll = true
                    "
                />
                <span v-if="canUnmerge" v-b-tooltip.hover title="Unmerge">
                    <IconButton
                        icon="ArrowsCollapse"
                        variant="outline-primary"
                        class="my-1 btn-focus-none d-flex justify-content-center align-items-center"
                        @click="unmergeCells"
                    />
                </span>
                <span v-else v-b-tooltip.hover title="Merge">
                    <IconButton
                        :disabled="noCellsSelected || !isMergeable"
                        icon="Merge"
                        variant="outline-primary"
                        class="my-1 btn-focus-none d-flex justify-content-center align-items-center"
                        @click="handleBeforeCellsMerge"
                    />
                </span>

                <TableSettingsDropdown
                    id="border_setting"
                    :disabled="noCellsSelected"
                    title="Border"
                    icon="BorderSetting"
                    @click="setStyleSettingType('border')"
                >
                    <template #content>
                        <div class="cell-style-border-settings">
                            <div class="style-settings-item py-1 px-2">
                                <h6 class="text-center">Border</h6>
                                <div class="d-flex justify-content-around px-1">
                                    <IconButton
                                        :class="{ active: selectedCellsBorderStyle === 'all' }"
                                        class="p-1"
                                        icon="BorderAll"
                                        variant="outline-primary"
                                        @click="setTableBorder('all')"
                                    />
                                    <IconButton
                                        :class="{ active: selectedCellsBorderStyle === 'none' }"
                                        class="p-1"
                                        icon="BorderNone"
                                        variant="outline-primary"
                                        @click="setTableBorder('none')"
                                    />
                                </div>
                                <hr />
                                <div class="d-flex justify-content-around align-items-center">
                                    <IconButton
                                        :class="{ active: selectedCellsBorderStyle === 'left' }"
                                        class="p-1 mr-1"
                                        icon="BorderLeft"
                                        variant="outline-primary"
                                        @click="setTableBorder('left')"
                                    />
                                    <div class="d-flex flex-column">
                                        <IconButton
                                            :class="{ active: selectedCellsBorderStyle === 'top' }"
                                            class="p-1 my-1"
                                            icon="BorderTop"
                                            variant="outline-primary"
                                            @click="setTableBorder('top')"
                                        />
                                        <IconButton
                                            :class="{ active: selectedCellsBorderStyle === 'bottom' }"
                                            class="p-1 my-1"
                                            icon="BorderBottom"
                                            variant="outline-primary"
                                            @click="setTableBorder('bottom')"
                                        />
                                    </div>
                                    <IconButton
                                        :class="{ active: selectedCellsBorderStyle === 'right' }"
                                        class="p-1 ml-1"
                                        icon="BorderRight"
                                        variant="outline-primary"
                                        @click="setTableBorder('right')"
                                    />
                                </div>
                            </div>
                        </div>
                    </template>
                </TableSettingsDropdown>

                <TableSettingsDropdown
                    id="background_fill"
                    :disabled="noCellsSelected"
                    icon="FillColor"
                    title="Fill"
                    @click="setStyleSettingType('backgroundColor')"
                >
                    <template #content>
                        <div class="cell-style-settings">
                            <div class="style-settings-item p-2">
                                <p class="text-center">Background Color</p>
                                <b-form-input
                                    v-model="cellBackgroundColor"
                                    type="color"
                                    class="m-0"
                                    @input="handleCellBackgroundColorChange"
                                ></b-form-input>
                            </div>
                        </div>
                    </template>
                </TableSettingsDropdown>
            </div>

            <b-modal v-model="deleteCellsModalActive" centered hide-header hide-footer>
                <div class="d-flex justify-content-center">
                    <svg width="45" height="42" viewBox="0 0 24 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M12 4.76041L20.1575 18.3125H3.84251L12 4.76041ZM12 0.604156L0.0833435 20.3958H23.9167L12 0.604156ZM13.0833 15.1875H10.9167V17.2708H13.0833V15.1875ZM13.0833 8.93749H10.9167V13.1042H13.0833V8.93749Z"
                            fill="#DD0D32"
                        />
                    </svg>
                </div>
                <h4 class="text-center mt-3">Are you sure?</h4>
                <div class="d-flex justify-content-center">
                    <p class="w-75 text-center">This will permanently delete your cells and cannot be undone</p>
                </div>
                <div class="d-flex justify-content-around px-5 mt-4">
                    <b-button variant="danger" size="lg" @click="removeTableCells">Delete</b-button>
                    <b-button variant="secondary" size="lg" @click="deleteCellsModalActive = false">Cancel</b-button>
                </div>
            </b-modal>
            <b-modal v-model="insufficientColumnSpaceActive" centered hide-footer hide-header>
                <div class="d-flex justify-content-center">
                    <svg width="45" height="42" viewBox="0 0 24 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M12 4.76041L20.1575 18.3125H3.84251L12 4.76041ZM12 0.604156L0.0833435 20.3958H23.9167L12 0.604156ZM13.0833 15.1875H10.9167V17.2708H13.0833V15.1875ZM13.0833 8.93749H10.9167V13.1042H13.0833V8.93749Z"
                            fill="#2F80ED"
                        />
                    </svg>
                </div>
                <h4 class="text-center mt-3">Insufficient Space</h4>
                <div class="d-flex justify-content-center">
                    <p class="w-75 text-center">
                        Sorry! There's not enough room to add a new column. Try resizing the width of your existing columns
                        to make more space.
                    </p>
                </div>
                <div class="d-flex justify-content-center mt-4">
                    <b-button variant="secondary" @click="insufficientColumnSpaceActive = false">Close</b-button>
                </div>
            </b-modal>
            <b-modal v-model="clearCells.active" centered hide-header hide-footer>
                <div class="d-flex justify-content-center">
                    <svg width="45" height="42" viewBox="0 0 24 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M12 4.76041L20.1575 18.3125H3.84251L12 4.76041ZM12 0.604156L0.0833435 20.3958H23.9167L12 0.604156ZM13.0833 15.1875H10.9167V17.2708H13.0833V15.1875ZM13.0833 8.93749H10.9167V13.1042H13.0833V8.93749Z"
                            fill="#DD0D32"
                        />
                    </svg>
                </div>
                <h4 class="text-center mt-3">Are you sure?</h4>
                <div class="d-flex justify-content-center">
                    <p class="w-75 text-center">
                        {{
                            clearCells.isAll
                                ? 'This will delete all text from all cells and cannot be undone'
                                : 'This will delete all text from selected cells and cannot be undone'
                        }}
                    </p>
                </div>
                <div class="d-flex justify-content-around px-5 mt-4">
                    <b-button variant="danger" size="lg" @click="clearAllContent">
                        {{ clearCells.isAll ? 'Clear All' : 'Clear' }}
                    </b-button>
                    <b-button variant="secondary" size="lg" @click="clearCells.active = false">Cancel</b-button>
                </div>
            </b-modal>
            <b-modal v-model="resizeModal.active" centered hide-header hide-footer>
                <div class="d-flex justify-content-center">
                    <svg width="45" height="42" viewBox="0 0 24 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M12 4.76041L20.1575 18.3125H3.84251L12 4.76041ZM12 0.604156L0.0833435 20.3958H23.9167L12 0.604156ZM13.0833 15.1875H10.9167V17.2708H13.0833V15.1875ZM13.0833 8.93749H10.9167V13.1042H13.0833V8.93749Z"
                            fill="#DD0D32"
                        />
                    </svg>
                </div>
                <h4 class="text-center mt-3">Resize table?</h4>
                <div class="d-flex justify-content-center">
                    <p class="w-75 text-center">This will permanently delete the highlighted cells and cannot be undone.</p>
                </div>
                <div class="d-flex justify-content-around px-5 mt-4">
                    <b-button variant="danger" size="lg" @click="submitResizeTable">Resize</b-button>
                    <b-button variant="secondary" size="lg" @click="resizeModal.active = false">Cancel</b-button>
                </div>
            </b-modal>
            <b-modal v-model="mergeCellsModal.active" centered hide-header hide-footer>
                <div class="d-flex justify-content-center">
                    <svg width="45" height="42" viewBox="0 0 24 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M12 4.76041L20.1575 18.3125H3.84251L12 4.76041ZM12 0.604156L0.0833435 20.3958H23.9167L12 0.604156ZM13.0833 15.1875H10.9167V17.2708H13.0833V15.1875ZM13.0833 8.93749H10.9167V13.1042H13.0833V8.93749Z"
                            fill="#DD0D32"
                        />
                    </svg>
                </div>
                <h4 class="text-center mt-3">Merge table?</h4>
                <div class="d-flex justify-content-center">
                    <p class="w-75 text-center">Your cells contain text</p>
                </div>
                <div class="d-flex justify-content-between px-1 mt-4" style="flex-wrap: wrap">
                    <b-button variant="secondary" size="lg" class="mt-2" @click="cellMergeTextStatus('keepAll')">
                        Keep all texts
                    </b-button>

                    <b-button variant="secondary" size="lg" class="mt-2" @click="cellMergeTextStatus('keepFirst')">
                        Keep first cell
                    </b-button>
                    <b-button variant="secondary" size="lg" class="mt-2" @click="cellMergeTextStatus('removeAll')">
                        Remove all
                    </b-button>
                    <b-button variant="secondary" size="lg" class="mt-2" @click="mergeCellsModal.active = false">
                        Cancel
                    </b-button>
                </div>
            </b-modal>
        </div>
        <div class="row mb-2">
            <div v-if="!noCellsSelected" class="col-md-6 d-flex flex-column">
                <label class="text-sm mb-1 f-11 text-muted d-flex">
                    <div class="font-weight-bold text-nowrap">Alignment</div>
                </label>
                <b-form-select
                    v-model="textAlignment"
                    :options="tableAlignments"
                    size="sm"
                    @input="handleTextAlignment"
                ></b-form-select>
            </div>
            <div v-if="selectedColumns.length" class="col-md-6 d-flex flex-column">
                <label class="text-sm mb-0 f-11 text-muted d-flex justify-content-between">
                    <div class="font-weight-bold text-nowrap">Column Width</div>
                    <div class="text-secondary">{{ columnWidth }}in</div>
                </label>
                <div class="d-flex f-10 align-items-center mb-0 mt-1">
                    <b-form-input
                        v-model="columnWidth"
                        type="range"
                        min="0.4"
                        :max="getAvailableWidth"
                        step="0.1"
                        @input="handleColWidthChange"
                    ></b-form-input>
                </div>
            </div>
            <div v-else-if="activeCellRow" class="col-md-6 d-flex flex-column">
                <label class="text-sm mb-0 f-11 text-muted d-flex justify-content-between">
                    <div class="font-weight-bold text-nowrap">Row Height</div>
                    <div class="text-secondary">{{ rowHeight }}in</div>
                </label>
                <div class="d-flex f-10 align-items-center mb-0 mt-1">
                    <b-form-input
                        v-model="rowHeight"
                        type="range"
                        min="0.4"
                        max="4"
                        step="0.1"
                        @input="handleRowHeightChange"
                    ></b-form-input>
                </div>
            </div>
            <div v-if="activeCell && inputCellImage?.length" class="col-md-6 d-flex flex-column">
                <label class="font-weight-bold mb-1 f-11 text-muted">Text Placement</label>
                <div v-show="activeCell.style.alignment === 'center'">
                    <div class="d-flex w-100">
                        <div class="d-flex align-items-center mr-3">
                            <b-form-radio
                                v-model="inputItemTextPlacement"
                                name="text_placement"
                                value="below"
                                @change="updateData"
                            >
                                <div class="text-muted f-12" style="height: 1.5rem; line-height: 1.5rem">Below</div>
                            </b-form-radio>
                        </div>
                        <div class="d-flex align-items-center">
                            <b-form-radio
                                v-model="inputItemTextPlacement"
                                name="text_placement"
                                value="above"
                                @change="updateData"
                            >
                                <div class="text-muted f-12" style="height: 1.5rem; line-height: 1.5rem">Above</div>
                            </b-form-radio>
                        </div>
                    </div>
                </div>
                <div v-show="activeCell.style.alignment !== 'center'">
                    <div class="d-flex w-100">
                        <div class="d-flex align-items-center mr-3">
                            <b-form-radio
                                v-model="inputItemImagePlacement"
                                name="image_placement"
                                value="left"
                                @change="updateData"
                            >
                                <div class="text-muted f-12" style="height: 1.5rem; line-height: 1.5rem">Left</div>
                            </b-form-radio>
                        </div>
                        <div class="d-flex align-items-center">
                            <b-form-radio
                                v-model="inputItemImagePlacement"
                                name="image_placement"
                                value="right"
                                @change="updateData"
                            >
                                <div class="text-muted f-12" style="height: 1.5rem; line-height: 1.5rem">Right</div>
                            </b-form-radio>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <b-card v-show="inputItem.row && inputItem.col" class="mt-3 mb-2 position-relative border-0 cell-editor" no-body>
            <b-card-header class="py-3 position-relative"></b-card-header>
            <b-card-body class="p-0 d-flex">
                <VueEditor
                    ref="editor"
                    v-model="inputCellText"
                    :editor-toolbar="customToolbar"
                    :editor-options="editorSettings"
                    placeholder="Enter text"
                    class="cell-input"
                    @text-change="updateData"
                ></VueEditor>
                <InlineImageBtn
                    :image-id="inputCellImage"
                    :item-index="index"
                    :input-item="inputItem"
                    :btn-class="['cell-inline-image-btn']"
                    @deleted="inputCellImage = null"
                />
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import { defineComponent } from 'vue'
import { mapGetters } from 'vuex'
import TableWidgetCell from '../../store/models/TableWidgetCell'
import TableWidgetRow from '../../store/models/TableWidgetRow'
import { VueEditor } from 'vue2-editor'
import { MergeMixins } from '../../mixins/TableWidgetMerge'
import RowColumnActions from '../tables/RowColumnActions.vue'
import TableSettingsDropdown from '../tables/TableSettingsDropdown.vue'
import { reactive } from 'vue'
import { cloneDeep } from 'lodash'
import IconButton from '../../stories/components/buttons/IconButton.vue'
import IconPlus from '../../stories/components/icons/IconPlus.vue'
import InlineImageBtn from '../../components/AddInlineImageButton.vue'
import InlineImagesMixin from '../../mixins/InlineImages'

export default defineComponent({
    name: 'TableWidget',
    components: {
        VueEditor,
        RowColumnActions,
        TableSettingsDropdown,
        IconButton,
        IconPlus,
        InlineImageBtn,
    },
    mixins: [MergeMixins, InlineImagesMixin],
    props: ['data', 'index', 'id'],
    data() {
        return {
            defaultRowsCount: 5,
            defaultColumnsCount: 10,
            itemData: {
                ...this.data,
            },
            hoverItems: {
                row: null,
                col: null,
            },
            inputItem: {
                row: null,
                col: null,
            },
            activeCellRow: null,
            deleteCellsModalActive: false,
            deleteRowId: null,
            selectedColumns: [],
            deleteCellDirection: null,
            styleSettingType: null,
            cellBackgroundColor: null,
            insufficientColumnSpaceActive: false,
            customToolbar: [['bold', 'italic', 'underline'], [{ color: [] }], [{ list: 'ordered' }, { list: 'bullet' }]],
            allCellsSelected: false,
            defaultRowHeight: 0.5,
            rowHeight: 0.5,
            defaultColumnWidth: 2.5,
            columnWidth: 2.5,
            clearCells: {
                active: false,
                isAll: false,
            },
            resizeModal: {
                row: null,
                col: null,
                active: false,
            },
            shiftDown: false,
            selectedCells: [],
            editorSettings: {
                modules: {
                    keyboard: {
                        bindings: {
                            enter: {
                                key: 13,
                                handler: function () {
                                    if (self === window) return true
                                    self.onNextFocus()
                                    return false
                                },
                            },
                            tab: {
                                key: 9,
                                handler: function () {
                                    if (self === window) return true
                                    self.onNextFocus()
                                    return false
                                },
                            },
                        },
                    },
                },
            },
            tableAlignments: [
                { value: '', text: '-- Set alignment --', disabled: true },
                { value: 'left', text: 'Left' },
                { value: 'center', text: 'Center' },
                { value: 'right', text: 'Right' },
            ],
            quillEditor: null,
            defaultCellLength: {
                height: 22,
                width: 22,
            },
            displayCellMargin: 27.6,
            textAlignment: 'center',
        }
    },
    computed: {
        ...mapGetters({
            documentItems: 'document/documentItems',
            currentTableWidgetCell: 'document/currentTableWidgetCell',
        }),
        getColSettingsLeft() {
            if (this.selectedColumns.length === 1) {
                return `left: ${27 + 28 * (this.selectedColumns[0] - 1)}px`
            } else {
                return `left: ${27 + 28 * (this.selectedColumns[this.selectedColumns.length - 1] - 1)}px`
            }
        },
        getAvailableWidth() {
            return 4
        },
        noCellsSelected() {
            return (
                !this.allCellsSelected &&
                !this.selectedColumns.length &&
                !this.activeCellRow &&
                !this.selectedCells.length &&
                !(this.inputItem?.row && this.inputItem?.col)
            )
        },
        inputCellText: {
            get() {
                return this.activeCell?.term || ''
            },
            set(value) {
                if (!this.activeCell?.term) return
                this.itemData.table_data[this.inputItem.row - 1].cells[this.inputItem.col - 1].term = value
            },
        },
        selectedCellsBorderStyle() {
            if (this.noCellsSelected) return false

            const row = this.firstSelectedCell.row
            const col = this.firstSelectedCell.col

            if (!col || !row) return false

            const cell = this.itemData.table_data[row - 1]?.cells[col - 1]
            return cell?.style?.border_side
        },
        allCells() {
            let cells = []
            if (!this.allCellsSelected) return cells

            for (let i = 1; i <= this.itemData.rows_count; i++) {
                let row = { row: i, columns: [] }
                for (let j = 1; j <= this.itemData.columns_count; j++) {
                    row.columns.push(j)
                }
                cells.push(row)
            }
            return cells
        },
        firstSelectedCell() {
            let col, row
            if (this.allCellsSelected) {
                col = this.allCells[0].columns[0]
                row = this.allCells[0].row
            } else if (this.inputItem?.row && this.inputItem?.col) {
                col = this.inputItem.col
                row = this.inputItem.row
            } else if (this.selectedColumns.length) {
                col = this.selectedColumns[0]
                row = 1
            } else if (this.selectedCells.length) {
                col = this.selectedCells[0].columns[0]
                row = this.selectedCells[0].row
            }
            return { row, col }
        },
        inputCellImage: {
            get() {
                return this.activeCell?.term_image
            },
            async set(value) {
                const objectId = this.itemData?.table_data[this.inputItem.row - 1]?.cells[this.inputItem.col - 1]?.term_image
                if (objectId) {
                    await this.$store.dispatch('document/removeInlineImage', { objectId })
                }
                this.itemData.table_data[this.inputItem.row - 1].cells[this.inputItem.col - 1].term_image = value
                this.updateData()
            },
        },
        inputItemTextPlacement: {
            get() {
                return this.activeCell?.style?.text_placement || 'below'
            },
            set(value) {
                if (!this.activeCell) return
                this.itemData.table_data[this.inputItem.row - 1].cells[this.inputItem.col - 1].style.text_placement = value
            },
        },
        inputItemImagePlacement: {
            get() {
                return this.activeCell?.style?.image_placement === 'right' ? 'left' : 'right'
            },
            set(value) {
                if (!this.activeCell) return
                this.itemData.table_data[this.inputItem.row - 1].cells[this.inputItem.col - 1].style.image_placement =
                    value === 'left' ? 'right' : 'left'
            },
        },
        activeCell() {
            return this.itemData.table_data[this.inputItem.row - 1]?.cells[this.inputItem.col - 1]
        },
    },
    watch: {
        itemData: {
            immediate: true,
            deep: true,
            handler(val) {
                if (val.rows_count > this.defaultRowsCount) {
                    this.defaultRowsCount = val.rows_count
                }
            },
        },
        deleteCellsModalActive: {
            immediate: true,
            handler(val) {
                if (!val) {
                    this.deleteRowId = null
                }
            },
        },
        currentTableWidgetCell: {
            immediate: true,
            handler(val) {
                if (val.row && val.col) {
                    if (this.quillEditor)
                        this.quillEditor.root.innerHTML = this.itemData.table_data[val.row - 1].cells[val.col - 1].term
                    this.focusCell(val)
                }
            },
        },
        selectedColumns(val) {
            if (val.length === 0) return

            const selectedColumnsWidth = this.itemData.table_data[0].cells[val[0] - 1].style.width
            this.columnWidth =
                selectedColumnsWidth === 'auto' ? this.defaultColumnWidth : selectedColumnsWidth || this.defaultColumnWidth
        },
        inputItem(val) {
            if (val && val.row && val.col) {
                const alignment = this.activeCell.style.alignment
                this.textAlignment = alignment != '' ? alignment : this.itemData.table_horizontal_align
            }
        },
        activeCellRow: {
            handler(newVal) {
                if (!newVal) return
                const selectedRowHeight = this.itemData.table_data[newVal - 1].cells[0].style.height
                this.rowHeight =
                    selectedRowHeight === 'auto' ? this.defaultRowHeight : selectedRowHeight || this.defaultRowHeight
            },
        },
    },
    mounted() {
        this.defaultRowsCount = this.itemData.table_data.length

        this.setQuillEditorElement()

        document.addEventListener('keydown', (e) => {
            this.shiftDown = e.shiftKey || e.key.toLowerCase() === 'shift' || e.keyCode === 16
        })

        document.addEventListener('keyup', (e) => {
            if (e.key.toLowerCase() === 'shift' || e.keyCode === 16) this.shiftDown = false
        })

        this.focusCell({ row: 1, col: 1 })
    },
    methods: {
        setQuillEditorElement() {
            if (!this.$refs.editor) return

            this.quillEditor = this.$refs.editor?.quill
            this.quillEditor.on('text-change', () => {
                if (!this.activeCell) return
                this.itemData.table_data[this.inputItem.row - 1].cells[this.inputItem.col - 1].term =
                    this.quillEditor.getText() ? this.quillEditor.root.innerHTML.replace('<br>', '') : ''
                this.handleNewAddInput()
            })
        },
        updateData() {
            this.$emit(
                'change',
                Object.assign(this.data, {
                    ...this.itemData,
                }),
            )
        },
        handleCellHover(row, col) {
            if (row > this.itemData.rows_count || col > this.itemData.columns_count) {
                this.hoverItems = { row, col }
            } else {
                this.hoverItems = { row: null, col: null }
            }
        },
        handleCellLeave() {
            this.hoverItems = { row: null, col: null }
        },
        handleCellClick(row, col) {
            if (this.allCellsSelected) this.toggleSelectAll()

            if (row <= this.itemData.rows_count && col <= this.itemData.columns_count) {
                if (this.shiftDown) {
                    this.inputItem = { row: null, col: null }
                    let item = this.selectedCells.findIndex((item) => item.row === row)
                    if (item !== -1) {
                        let colItem = this.selectedCells[item].columns.indexOf(col)
                        if (colItem !== -1) {
                            this.selectedCells[item].columns.splice(colItem, 1)
                            if (this.selectedCells[item].columns.length === 0) {
                                this.selectedCells.splice(item, 1)
                            }
                        } else {
                            this.selectedCells[item].columns.push(col)
                        }
                    } else {
                        this.selectedCells.push({ row, columns: [col] })
                    }
                    this.sortSelectedCells()
                    this.checkIfMergableCells()
                } else {
                    this.selectedCells = []
                    if (row === this.inputItem.row && col === this.inputItem.col) {
                        this.clearFocusCell()
                    } else {
                        this.focusCell({ row, col })
                    }
                    this.checkIfMergableCells()
                }
            } else {
                this.clearFocusCell()
                if (row < this.itemData.rows_count || col < this.itemData.columns_count) {
                    this.resizeModal.row = row
                    this.resizeModal.col = col
                    this.resizeModal.active = true
                } else {
                    this.resizeTableCells(row, col)
                }
                this.handleCellLeave()
            }
        },
        resizeTableCells(row, col) {
            let oldTableData = { table_data: this.itemData.table_data || [] }
            let currentRows = this.itemData.table_data.length
            while (currentRows > row) {
                currentRows -= 1
                if (this.defaultRowsCount > 5) this.defaultRowsCount -= 1
                this.itemData.table_data.splice(currentRows, 1)
            }

            for (let i = 0; i < row; i++) {
                if (oldTableData.table_data[i]) {
                    let cells = []
                    for (let j = 0; j < col; j++) {
                        if (typeof oldTableData.table_data[i].cells[j] != 'undefined') {
                            cells.push(oldTableData.table_data[i].cells[j])
                        } else {
                            cells.push(reactive({ ...new TableWidgetCell() }))
                        }
                    }
                    oldTableData.table_data[i] = { cells: cells }
                } else {
                    oldTableData.table_data[i] = reactive({ ...new TableWidgetRow(col) })
                }
            }

            oldTableData.rows_count = row
            oldTableData.columns_count = col
            this.itemData = oldTableData
            this.updateData()
        },
        submitResizeTable() {
            this.resizeModal.active = false
            this.resizeTableCells(this.resizeModal.row, this.resizeModal.col)
        },
        handleNewAddInput() {
            this.updateData()
        },
        addNewTableRow() {
            let newData = { ...this.data }
            newData.table_data.push({ ...new TableWidgetRow(newData.columns_count) })
            newData.rows_count += 1
            this.defaultRowsCount += 1
            this.itemData = newData
            this.updateData()
        },
        addNewRow(row) {
            this.itemData.table_data.splice(row - 1, 0, { ...new TableWidgetRow(this.itemData.columns_count) })
            this.itemData.rows_count += 1
            this.defaultRowsCount += 1
            this.updateData()
        },
        setActiveRowCircle(row) {
            if (this.allCellsSelected) this.toggleSelectAll()

            if (this.activeCellRow === row) {
                this.activeCellRow = null
            } else {
                this.resetSelections('row')
                this.textAlignment = ''
                this.clearFocusCell()
                this.activeCellRow = row
                this.checkRowDisabledCells()
            }
        },
        handleDeleteRow(row) {
            this.deleteRowId = row
            this.deleteCellDirection = 'row'
            this.deleteCellsModalActive = true
        },
        handleDeleteColumn() {
            this.deleteCellDirection = 'col'
            this.deleteCellsModalActive = true
        },
        removeTableCells() {
            this.clearFocusCell()
            if (this.allCellsSelected) {
                this.itemData.table_data = []
                this.itemData.columns_count = 0
                this.itemData.rows_count = 0
                this.allCellsSelected = false
            } else {
                if (this.deleteCellDirection === 'row') {
                    this.getDeleteRow()
                } else {
                    this.getDeleteColumn()
                }
            }
            this.deleteCellsModalActive = false
            this.resetSelectedCells()
            this.updateData()
        },
        duplicateRow(row) {
            this.activeCellRow = null
            const rowData = cloneDeep(this.itemData.table_data[row - 1])
            rowData.cells.forEach((cell) => {
                this.resetCellData(cell)
            })
            this.itemData.table_data.push(rowData)
            this.itemData.rows_count += 1
            this.defaultRowsCount += 1
            this.updateData()
        },
        duplicateColumn() {
            if (this.selectedColumns.length + this.itemData.columns_count > 10) {
                this.insufficientColumnSpaceActive = true
            } else {
                let oldTableData = { ...this.itemData }
                for (let i = 0; i < this.itemData.table_data.length; i++) {
                    this.selectedColumns.forEach((item) => {
                        const cellData = cloneDeep(oldTableData.table_data[i].cells[item - 1])
                        this.resetCellData(cellData)
                        oldTableData.table_data[i].cells.push(cellData)
                    })
                }
                this.itemData.table_data = oldTableData.table_data
                this.itemData.columns_count += this.selectedColumns.length
                this.updateData()
                this.resetSelectedColumns()
            }
        },
        selectColumn(column) {
            if (this.allCellsSelected) this.toggleSelectAll()

            this.textAlignment = ''
            const isColumnSelected = this.selectedColumns.includes(column)

            if (isColumnSelected) {
                this.handleSelectedColumn(column)
            } else {
                this.resetSelections('column')
                this.selectedColumns.push(column)
            }

            if (this.selectedColumns.length > 0) {
                this.clearFocusCell()
                this.checkColumnsDisabledCells()
            }
        },
        handleSelectedColumn(column) {
            if (this.shiftDown) {
                this.selectedColumns = this.selectedColumns.filter((col) => col !== column)
            } else {
                if (this.selectedColumns.length > 1) {
                    this.selectedColumns = [column]
                    return
                }
                this.resetSelectedColumns()
            }
        },
        getDeleteRow() {
            let rowIndex = null,
                colIndex = null
            for (let i = 0; i < this.itemData.table_data[this.deleteRowId - 1].cells.length; i++) {
                if (
                    this.itemData.table_data[this.deleteRowId - 1].cells[i].headRowIndex !== null &&
                    this.itemData.table_data[this.deleteRowId - 1].cells[i].headColIndex !== null
                ) {
                    if (
                        rowIndex !== this.itemData.table_data[this.deleteRowId - 1].cells[i].headRowIndex &&
                        colIndex !== this.itemData.table_data[this.deleteRowId - 1].cells[i].headColIndex
                    ) {
                        rowIndex = this.itemData.table_data[this.deleteRowId - 1].cells[i].headRowIndex
                        colIndex = this.itemData.table_data[this.deleteRowId - 1].cells[i].headColIndex
                        this.itemData.table_data[rowIndex].cells[colIndex].style.row_span -= 1
                    }
                }
            }
            this.itemData.table_data.splice(this.deleteRowId - 1, 1)
            this.deleteCellsModalActive = false
            this.itemData.rows_count -= 1
            if (this.defaultRowsCount > 5) this.defaultRowsCount -= 1
            this.resetActiveRows()
            this.updateData()
        },
        getDeleteColumn() {
            let oldTableData = { ...this.itemData }
            let rowIndex = null,
                colIndex = null
            this.selectedColumns.sort()
            this.selectedColumns.reverse()
            let colFlag

            for (let j = 0; j < this.selectedColumns.length; j++) {
                colFlag = true
                let item = this.selectedColumns[j]
                for (let i = 0; i < this.itemData.rows_count; i++) {
                    if (
                        oldTableData.table_data[i].cells[item - 1] &&
                        oldTableData.table_data[i].cells[item - 1].headRowIndex !== null &&
                        oldTableData.table_data[i].cells[item - 1].headColIndex !== null
                    ) {
                        rowIndex = oldTableData.table_data[i].cells[item - 1].headRowIndex
                        colIndex = oldTableData.table_data[i].cells[item - 1].headColIndex
                        if (colFlag) {
                            oldTableData.table_data[rowIndex].cells[colIndex].style.col_span -= 1
                            colFlag = false
                        }
                    }
                    if (
                        oldTableData.table_data[i].cells[item - 1] &&
                        i > 0 &&
                        oldTableData.table_data[i].cells[item - 1].disabled
                    ) {
                        oldTableData.table_data[i].cells[item].style.margin_left -= 27.6
                    }
                    oldTableData.table_data[i].cells[item - 1] = null
                }
            }

            for (let i = 0; i < this.itemData.rows_count; i++) {
                oldTableData.table_data[i].cells = oldTableData.table_data[i].cells.filter((val) => val)
            }

            this.itemData = oldTableData
            this.itemData.columns_count -= this.selectedColumns.length
            this.resetSelectedColumns()
            this.updateData()
        },
        setStyleSettingType(type) {
            if (this.styleSettingType === type) {
                this.styleSettingType = null
            } else this.styleSettingType = type
        },
        handleCellBackgroundColorChange() {
            if (this.allCellsSelected) {
                this.applyStyleToCells(this.allCells, 'background_color', this.cellBackgroundColor)
            } else if (this.inputItem?.row && this.inputItem?.col) {
                this.itemData.table_data[this.inputItem.row - 1].cells[this.inputItem.col - 1].style.background_color =
                    this.cellBackgroundColor
            } else if (this.selectedColumns.length) {
                for (let i = 0; i < this.defaultRowsCount; i++) {
                    this.selectedColumns.forEach((val) => {
                        this.itemData.table_data[i].cells[val - 1].style.background_color = this.cellBackgroundColor
                    })
                }
            } else if (this.activeCellRow) {
                for (let i = 0; i < this.itemData.columns_count; i++) {
                    this.itemData.table_data[this.activeCellRow - 1].cells[i].style.background_color =
                        this.cellBackgroundColor
                }
            } else if (this.selectedCells.length) {
                this.applyStyleToCells(this.selectedCells, 'background_color', this.cellBackgroundColor)
            }
            this.updateData()
        },
        getCellWidth(row_span) {
            var total = 0
            if (row_span === 1) {
                return '22'
            } else {
                for (let i = 1; i <= row_span; i++) {
                    total += 22
                    total += i < row_span ? 4.5 : row_span * 0.8
                }
                return total
            }
        },
        getCellHeight(row_span) {
            var total = 0
            if (row_span === 1) {
                return '22'
            } else {
                for (let i = 1; i <= row_span; i++) {
                    total += 22
                    total += i < row_span ? 4.5 : row_span * 1.7
                }
                return total
            }
        },
        setTableBorder(border) {
            if (this.allCellsSelected) {
                this.applyStyleToCells(this.allCells, 'border_side', border)
            } else if (this.inputItem?.row && this.inputItem?.col) {
                this.itemData.table_data[this.inputItem.row - 1].cells[this.inputItem.col - 1].style.border_side = border
            } else if (this.selectedColumns.length) {
                for (let i = 0; i < this.defaultRowsCount; i++) {
                    this.selectedColumns.forEach((val) => {
                        this.itemData.table_data[i].cells[val - 1].style.border_side = border
                    })
                }
            } else if (this.activeCellRow) {
                for (let i = 0; i < this.itemData.table_data[this.activeCellRow - 1].cells.length; i++) {
                    this.itemData.table_data[this.activeCellRow - 1].cells[i].style.border_side = border
                }
            } else if (this.selectedCells.length) {
                this.applyStyleToCells(this.selectedCells, 'border_side', border)
            }
            this.updateData()
        },
        clearAllContent() {
            if (this.clearCells.isAll) {
                for (let i = 0; i < this.itemData.rows_count; i++) {
                    for (let j = 0; j < this.itemData.columns_count; j++) {
                        this.itemData.table_data[i].cells[j].term = ''
                        this.itemData.table_data[i].cells[j].term_image = null
                    }
                }
                this.clearQuillEditor()
            } else {
                if (this.selectedColumns.length) {
                    for (let i = 0; i < this.itemData.rows_count; i++) {
                        this.selectedColumns.forEach((val) => {
                            if (this.itemData.table_data[i]) {
                                this.itemData.table_data[i].cells[val - 1].term = ''
                                this.itemData.table_data[i].cells[val - 1].term_image = null
                            }
                        })
                    }
                    if (this.selectedColumns.includes(this.inputItem.col)) {
                        this.clearQuillEditor()
                    }
                    this.selectedColumns = []
                } else if (this.activeCellRow) {
                    for (let i = 0; i < this.itemData.table_data[this.activeCellRow - 1].cells.length; i++) {
                        this.itemData.table_data[this.activeCellRow - 1].cells[i].term = ''
                        this.itemData.table_data[this.activeCellRow - 1].cells[i].term_image = null
                    }
                    if (this.inputItem.row == this.activeCellRow) this.clearQuillEditor()

                    this.activeCellRow = null
                }
            }
            this.clearCells.active = false
            this.updateData()
        },
        clearQuillEditor() {
            if (this.quillEditor) {
                this.quillEditor.setContents([])
            }
        },
        clearRow(row) {
            this.activeCellRow = row
            this.clearCells.isAll = false
            this.clearCells.active = true
        },
        clearColumns() {
            this.clearCells.isAll = false
            this.clearCells.active = true
        },
        focusCell(val) {
            this.inputItem = val
            this.clearRowColumnSelection()
            this.$nextTick(() => {
                const quill = this.quillEditor?.root
                if (quill) {
                    quill.innerHTML =
                        this.itemData.table_data[this.inputItem.row - 1].cells[this.inputItem.col - 1]?.term || ''
                    let range = document.createRange()
                    let sel = window.getSelection()
                    if (range && this.itemData.table_data[val.row - 1].cells[val.col - 1].term) {
                        range.setStart(quill, 1)
                        range.collapse(true)
                        if (sel) {
                            sel.removeAllRanges()
                            sel.addRange(range)
                        }
                    }
                    quill.focus()
                }
            })
        },
        addColumnBetween(col) {
            if (this.itemData.columns_count + 1 > 10) {
                this.insufficientColumnSpaceActive = true
            } else {
                for (let i = 0; i < this.itemData.rows_count; i++) {
                    this.itemData.table_data[i].cells.splice(col, 0, reactive({ ...new TableWidgetCell() }))
                }
                this.itemData.columns_count += 1
                this.updateData()
                this.selectedColumns = []
            }
        },
        getRowPosition(row) {
            return `position:absolute;top: ${(row - 1) * 29}px`
        },
        getMarginStyle(row, col) {
            if (this.itemData.table_data[row - 1]?.cells[col - 1]?.style.margin_left) {
                return `margin-left:${this.itemData.table_data[row - 1]?.cells[col - 1]?.style.margin_left}px`
            } else if (this.itemData.table_data[row - 1]?.cells[col - 1]?.style.margin_right) {
                return `margin-right:${this.itemData.table_data[row - 1]?.cells[col - 1]?.style.margin_right}px`
            }
        },
        handleColWidthChange() {
            for (let i = 0; i < this.itemData.rows_count; i++) {
                for (let j = 0; j < this.selectedColumns.length; j++) {
                    this.itemData.table_data[i].cells[this.selectedColumns[j] - 1].style.width = this.columnWidth
                }
            }

            this.updateData()
        },
        handleRowHeightChange() {
            for (let i = 0; i < this.itemData.columns_count; i++) {
                this.itemData.table_data[this.activeCellRow - 1].cells[i].style.height = this.rowHeight
            }
            this.updateData()
        },
        handleTextAlignment() {
            if (this.textAlignment === null || this.textAlignment === '') return

            if (this.allCellsSelected) {
                this.setAllCellsAlignment()
            } else if (this.selectedColumns.length > 0 || this.activeCellRow) {
                this.checkSelectedRowAndColumnCells()
            } else if (this.inputItem && this.inputItem.row && this.inputItem.col) {
                this.itemData.table_data[this.inputItem.row - 1].cells[this.inputItem.col - 1].style.alignment =
                    this.textAlignment
            } else {
                //else update whole table alignement
                this.itemData.table_horizontal_align = this.textAlignment
            }
            this.updateData()
        },
        clearFocusCell() {
            this.inputItem = {
                row: null,
                col: null,
            }
        },
        setAllCellsAlignment() {
            this.itemData.table_data.forEach((row) => {
                this.setGroupedCellsAlignment(row.cells)
            })
        },
        checkSelectedRowAndColumnCells() {
            this.itemData.table_data.forEach((row, index) => {
                if (this.activeCellRow && index == this.activeCellRow - 1) {
                    this.setGroupedCellsAlignment(row.cells)
                }

                if (this.selectedColumns.length > 0) {
                    this.selectedColumns.forEach((column) => {
                        this.setCellAlignment(row.cells[column - 1])
                    })
                }
            })
        },
        setGroupedCellsAlignment(cells) {
            cells.forEach((cell) => {
                this.setCellAlignment(cell)
            })
        },
        setCellAlignment(cell) {
            if (!cell || !cell.style) return
            cell.style.alignment = this.textAlignment
        },
        resetCellData(cell) {
            if (!cell) return
            cell.disabled = false
            cell.headRowIndex = null
            cell.headColIndex = null
            cell.style.margin_left = 0
            cell.style.margin_right = 0
            cell.style.row_span = 1
            cell.style.col_span = 1
        },
        resetSelectedColumns() {
            this.selectedColumns = []
            this.resetSelectedCells()
        },
        resetActiveRows() {
            this.activeCellRow = null
            this.resetSelectedCells()
        },
        resetSelections(direction = null) {
            if (direction && this.shiftDown) {
                return direction === 'row' ? this.resetSelectedColumns() : this.resetActiveRows()
            }

            this.resetActiveRows()
            this.resetSelectedColumns()
        },
        applyStyleToCells(cells, property, value) {
            for (let i = 0; i < cells.length; i++) {
                for (let j = 0; j < cells[i].columns.length; j++) {
                    this.itemData.table_data[cells[i].row - 1].cells[cells[i].columns[j] - 1].style[property] = value
                }
            }
        },
        resetSelectedCells() {
            this.selectedCells = []
        },
    },
})
</script>

<style lang="scss">
.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options {
    z-index: 10 !important;
}

.ql-picker:not(.ql-background) {
    top: 1px !important;
}

.cell-input {
    width: 100%;

    .ql-toolbar.ql-snow {
        position: absolute;
        top: 3px;
        left: 40%;
        transform: translateX(-40%);
        border: none !important;
        padding: 0 !important;
        .ql-formats {
            height: 20px;
            margin-right: 0;
            button {
                outline: none !important;
            }
        }
    }

    .ql-container {
        border-top: 1px solid #ccc !important;
        border-top-right-radius: 0;
        border-top-left-radius: 0;
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0.25rem;
        border-right: none !important;
        position: static;
        z-index: 8;
    }

    .ql-snow .ql-color-picker {
        width: inherit;
    }
}

.cell-inline-image-btn {
    border-top-right-radius: 0;
    border-top-left-radius: 0;
    border-bottom-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
}

.cell-editor {
    .card-header {
        border-bottom: 0;
        border-top: 1px solid rgba(0, 0, 0, 0.125);
        border-right: 1px solid rgba(0, 0, 0, 0.125);
        border-left: 1px solid rgba(0, 0, 0, 0.125);
    }
}
</style>
